import Vue from "vue";
import Vuex from "vuex";
import users from "./modules/users";
import survey from "./modules/survey";
import response from "./modules/response";
import charts from "./modules/charts";
import calendar from "./modules/calendar";
import auth from "./modules/auth";
import programs from "./modules/programs"
import projects from "./modules/projects";
import stakeholders from "./modules/stakeholders";
import conversations from "./modules/conversations";
import messages from "./modules/messages";
import surveyResponseFiltering from "./modules/surveyResponseFiltering";
import stakeholderList from "./modules/stakeholderList";
import stakeholderFiles from "./modules/stakeholderFiles";
import exhibits from "./modules/exhibits"
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    users,
    survey,
    response,
    auth,
    charts,
    programs,
    projects,
    calendar,
    stakeholders,
    conversations,
    messages,
    surveyResponseFiltering,
    stakeholderList,
    stakeholderFiles,
    exhibits
  }
});
